module.exports = __webpack_public_path__ + "img/lookbook-print.0c24884f.jpg";